const sections = document.querySelectorAll('.scroll-jacked');

function handleScroll() {
  const vh = window.innerHeight;

  sections.forEach((section) => {
    const bg = section.querySelector('.scroll-jacked__bg');
    const containers = section.querySelectorAll('.scroll-jacked__container');
    const containerCount = containers.length;
    const rect = section.getBoundingClientRect();

    function setContainerClasses(activeIndex) {
      containers.forEach((c, i) => {
        c.classList.toggle('is-visible', i === activeIndex);
        c.classList.toggle('is-before-scroll', i < activeIndex);
        c.classList.toggle('is-after-scroll', i > activeIndex);
      });
    }

    // Before section hits viewport
    if (rect.top > 0) {
      section.classList.add('is-before-viewport');
      section.classList.remove('is-in-viewport');
      section.classList.remove('is-after-viewport');
      setContainerClasses(0);
      return;
    }

    // While scrolling inside section
    if (rect.bottom > vh) {
      section.classList.add('is-in-viewport');
      section.classList.remove('is-before-viewport');
      section.classList.remove('is-after-viewport');

      // Scroll progress through this section: 0 when top hits viewport top, 1 when bottom hits viewport top
      const scrollableHeight = rect.bottom - rect.top - vh;
      const scrolled = -rect.top;
      const progress =
        scrollableHeight > 0
          ? Math.min(1, Math.max(0, scrolled / scrollableHeight))
          : 0;
      const activeIndex =
        containerCount > 0
          ? Math.min(Math.floor(progress * containerCount), containerCount - 1)
          : 0;

      setContainerClasses(activeIndex);
      return;
    }

    // When exiting (anchor to bottom of section)
    section.classList.add('is-after-viewport');
    section.classList.remove('is-before-viewport');
    section.classList.remove('is-in-viewport');
    setContainerClasses(containerCount - 1);
  });
}

window.addEventListener('scroll', handleScroll, { passive: true });
window.addEventListener('resize', handleScroll);
handleScroll();
